import classnames from 'classnames'
import * as React from 'react'

import {getAgentPoolHref} from '../../../../routes'
import {stringifyId} from '../../../../types'
import type {AgentPoolId, BuildId} from '../../../../types'
import {resolveRelative} from '../../../../utils/url'
import Link from '../../Link/Link'
import RouterLinkWrapper from '../../RouterLinkWrapper/RouterLinkWrapper'

import styles from './AgentPoolLink.css'

const linkParams = new URLSearchParams()
linkParams.set('tab', 'agentPools')
type AgentLinkProps = {
  buildId?: BuildId
  className?: string
  name?: string | null | undefined
  secondary?: boolean
  isSakuraUI?: boolean | null | undefined
  poolId?: AgentPoolId
}

const PROJECT_POOL = '<Project pool>'

function AgentPoolLink({className, name, poolId, secondary = true, isSakuraUI}: AgentLinkProps) {
  if (poolId == null || stringifyId(poolId) === '-2') {
    return null
  }

  let agentPoolUrl = getAgentPoolHref(poolId)

  if (isSakuraUI !== true) {
    agentPoolUrl = resolveRelative(`/agents.html?${linkParams.toString()}#${stringifyId(poolId)}`)
  }

  const classes = classnames(styles.agentPoolLink, className, {
    [styles.secondary]: secondary === true,
  })
  const poolName = name != null ? `${name} pool` : '<Project pool>'
  return (
    <RouterLinkWrapper>
      <Link
        href={agentPoolUrl}
        className={classes}
        title={`Agent pool: ${name ?? PROJECT_POOL}`}
        data-test-agent-pool-link
      >
        {poolName}
      </Link>
    </RouterLinkWrapper>
  )
}

export default React.memo<AgentLinkProps>(AgentPoolLink)
